import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home/Index.vue'
import TermsAndConditions from '../views/TermsAndConditions/Index.vue'
import PrivacyPolicy from '../views/PrivacyPolicy/Index.vue'
import Features from '../views/Features/Index.vue'
import Help from '../views/Help/Index.vue'
import AppDownload from '../views/AppDownload/Index.vue'
import Pricing from '../views/Pricing/Index.vue'
import Screenshots from '../views/Screenshots/Index.vue'

/** LAZY LOADING **/

Vue.use(VueRouter)

const routes = [
  { path: '/', component: Home,  meta: { requiresAuth: false } },
  { path: '/features', component: Features,  meta: { requiresAuth: false } },
  { path: '/screenshots', component: Screenshots,  meta: { requiresAuth: false } },
  { path: '/terms-and-conditions', component: TermsAndConditions,  meta: { requiresAuth: false } },
  { path: '/privacy-policy', component: PrivacyPolicy,  meta: { requiresAuth: false } },
  { path: '/help', component: Help,  meta: { requiresAuth: false } },
  { path: '/apps', component: AppDownload,  meta: { requiresAuth: false } },
  { path: '/pricing', component: Pricing,  meta: { requiresAuth: false } },
  { path: '*', component: Home,  meta: { requiresAuth: false } }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js